import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "14",
  fill: "none",
  viewBox: "0 0 11 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      d: "M7.481.501q.003 0 .01.007.002.001.003.01a.03.03 0 0 1-.005.02L4.258 5.043l-.507.706.865.083 5.394.52c.143.014.199.19.1.283l-6.906 6.187-.009.007-.007.006h-.003l-.005-.001-.01-.007-.003-.01a.03.03 0 0 1 .005-.02l-.001-.001 3.232-4.504.507-.705-.865-.084-5.393-.52H.65a.166.166 0 0 1-.1-.283L7.459.514l.008-.008Q7.472.5 7.474.5L7.477.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }